import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

/**
 * Behavior to execute when user clicks a button in the dialog
 */
interface DialogAction {
  label: string;
  effect: () => void;
}

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    standalone: true,
    imports: [MatDialogModule, MatButtonModule, NgIf]
})
export class ErrorComponent implements OnInit {

  error: string;
  cancel: DialogAction;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      error: string,
      actions: { confirm: DialogAction, cancel?: DialogAction }
    },
    private dialogRef: MatDialogRef<ErrorComponent>
  ) { }

  closeDialog(action: DialogAction) {
    action?.effect();
    this.dialogRef.close();
  }

  ngOnInit() {
    const { error, actions } = this.data;
    this.error = error;
    // this.confirm = actions.confirm;
    // console.log(this.confirm);
    
    if (actions.cancel) {
      this.cancel = this.data.actions.cancel;
    }
  }

}
